module.exports = __webpack_public_path__ + "static/media/radio.89052e79.svg";